import { Box } from "@mui/material";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Clients } from "src/context";
import http from "src/utils/http";
import Loading from "./Loading";

const LogoutClient = () => {
  const navigate = useNavigate();
  const { updateClient } = useContext(Clients);

  const handleLogout = async () => {
    let response = await http.post("/api/client-portal/logout");
    if (response.status === 200) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("__loginType");
      updateClient(null);
      navigate("/login/client-portal");
    }
  };

  React.useEffect(() => {
    handleLogout();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      sx={{
        height: "calc(100vh - 120px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Loading />
    </Box>
  );
};

export default LogoutClient;
